import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { authInterceptor, errorInterceptor, tokenRenewInterceptor } from '@core/interceptors';
import { AppInitService, AuthenticationService, CONFIRM_DIALOG_CONFIG, TOAST_CONFIG } from '@core/services';
import { ConfirmationService, MessageService } from 'primeng/api';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideDomandaActionHandlers } from '@core/services/domanda-action-handler/config/actions.config';
import { BASE_PATH } from '@data-access';
import { environment } from '@env/environment';
import { FLTheme } from '@ui/themes/fl.theme';
import { it } from 'primelocale/it.json';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { routes } from './app.routes';
import { fileUtilsHeaderInterceptor } from '@core/services/fileUtils';

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([authInterceptor, tokenRenewInterceptor, errorInterceptor, fileUtilsHeaderInterceptor])
    ),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideAnimationsAsync(),
    provideDomandaActionHandlers(),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    DialogService,
    ConfirmationService,
    MessageService,
    {
      provide: CONFIRM_DIALOG_CONFIG,
      useValue: {
        closable: false,
        closeOnEscape: false,
        dismissableMask: false,
        acceptLabel: 'SI',
        rejectLabel: 'NO',
        acceptButtonStyleClass: 'p-button-primary',
        rejectButtonStyleClass: 'p-button-secondary',
        blockScroll: true,
        defaultIcon: 'pi pi-exclamation-triangle',
      },
    },
    {
      provide: TOAST_CONFIG,
      useValue: {
        life: 10000,
        sticky: false,
      },
    },
    {
      provide: BASE_PATH,
      useValue: environment.apiUrl,
    },
    provideAppInitializer(() => {
      const authService = inject(AuthenticationService);
      const appInitService = inject(AppInitService);
      return authService.loadUserFromStorage().finally(() => {
        appInitService.setInitialized();
      });
    }),
    providePrimeNG({
      translation: it,
      ripple: true,
      theme: {
        preset: FLTheme,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
  ],
};
